import { css } from 'linaria';

export const benifitsStyles = css`
	.title {
		margin-bottom: 24px;
	}
`;
